import { store } from "@lib/stores";
import { LibraryItemWithProgressOutput } from "@lib/stores/myLibrary/types";
import * as Api from "@modules/api";
import { db } from "@modules/local/db";
import { useAppLiveQuery } from "@modules/local/hooks";

export function useLockedContent(
  context: Api.Server.ContentEntityOutput | null | undefined
) {
  const isLockedContent = useAppLiveQuery(async () => {
    // return measureExecutionTime('useLockedContent', async () => {
    if (!context?.id)
      return {
        isLocked: false,
        lockType: undefined,
      };

    // TODO: Add allowing list logic too

    const entityType = await db.entityTypes.get(
      context?.contentEntityTypeId ?? 0
    );
    const lockType = entityType?.lockType;

    if (lockType === Api.Server.LockType.Free)
      return {
        isLocked: false,
        lockType,
      };

    const { plans } =
      (await db.readerPlans.get(store.getState().auth.user.id ?? "")) ?? {};
    if (
      plans?.length &&
      plans?.find((myPlan) => myPlan.id && context?.plans?.includes(myPlan.id))
    )
      return {
        isLocked: false,
        lockType,
      };

    return {
      isLocked: true,
      lockType,
    };
    // });
  }, [context?.id, context?.contentEntityTypeId, context?.plans]);

  return { isLockedContent };
}

export function useLockedContents(
  contexts: (
    | Api.Server.ContentEntityOutput
    | LibraryItemWithProgressOutput
    | Api.Server.PlaylistContentEntityOutput
    | null
    | undefined
  )[]
) {
  const isLockedContent = useAppLiveQuery(async () => {
    // return measureExecutionTime('useLockedContent', async () => {
    let results = [];
    const { plans } =
      (await db.readerPlans.get(store.getState().auth.user.id ?? "")) ?? {};

    const contextsTypeIds = contexts.map(
      (context) => context?.contentEntityTypeId ?? 0
    );

    const entityTypes = await db.entityTypes
      .where("id")
      .anyOf(contextsTypeIds)
      .toArray();

    const allowedEntities = await db.allowedEntities.toArray();

    for (let i = 0; i < contexts.length; i++) {
      const context = contexts[i];
      if (!context?.id) {
        results.push({
          id: context?.id,
          isLocked: false,
          lockType: undefined,
        });

        continue;
      }

      const entityType = entityTypes.find(
        (et) => et.id === context?.contentEntityTypeId
      );
      const lockType = entityType?.lockType;

      if (
        lockType === Api.Server.LockType.Free ||
        lockType === Api.Server.LockType.FirstChapterFree
      ) {
        results.push({
          id: context.id,
          isLocked: false,
          lockType,
        });

        continue;
      }

      if (
        plans?.length &&
        plans?.find(
          (myPlan) => myPlan.id && context?.plans?.includes(myPlan.id)
        )
      ) {
        results.push({
          id: context.id,
          isLocked: false,
          lockType,
        });

        continue;
      }

      const isAllowedContentEntity = allowedEntities.find(
        (a) => a.id === context.id
      );

      if (isAllowedContentEntity) {
        results.push({
          id: context.id,
          isLocked: false,
          lockType,
        });

        continue;
      }

      results.push({
        id: context.id,
        isLocked: true,
        lockType,
      });
    }

    return results;
  }, [contexts?.map((s) => s?.id).join(",")]);
  return { isLockedContent };
}
